(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["takt-colour-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('takt-colour-gallery')) {
    customElements.define('takt-colour-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.sequence = 0;
        this.image = this.querySelector('.takt-ci-gallery__image');
        this.name = this.querySelector('[data-cg-name]');
        this.price = this.querySelector('[data-cg-price]');
        this.primary = this.querySelector('[data-cg-buy]');
        this.buyLabel = this.querySelector('[data-cg-buy-label]');
        this.status = this.querySelector('[data-cg-status]');
        this.loadingLabel = this.querySelector('[data-cg-loading]');
        this.error = this.querySelector('[data-cg-error]');
        this.active = this.querySelector('[data-cg-option]:checked');
        this.primary.addEventListener('click', (event) => {
          if (this.primary.getAttribute('aria-disabled') === 'true') event.preventDefault();
        }, { signal: this.events.signal });
        this.addEventListener('change', (event) => {
          const option = event.target.closest('[data-cg-option]');
          if (option) this.select(option);
        }, { signal: this.events.signal });
      }
      select(option) {
        const sequence = ++this.sequence;
        this.error.hidden = true;
        if (!this.image || !option.dataset.image) {
          this.commit(option);
          return;
        }
        this.setAttribute('aria-busy', 'true');
        this.primary.setAttribute('aria-disabled', 'true');
        this.loadingLabel.textContent = this.dataset.loading;
        this.loadingLabel.hidden = false;
        this.status.textContent = this.dataset.loading;
        const preload = new Image();
        preload.onload = () => {
          if (!this.isConnected || sequence !== this.sequence) return;
          this.image.removeAttribute('srcset');
          this.image.removeAttribute('sizes');
          this.image.src = option.dataset.image;
          this.image.alt = option.dataset.alt;
          this.commit(option);
        };
        preload.onerror = () => {
          if (!this.isConnected || sequence !== this.sequence) return;
          if (this.active) this.active.checked = true;
          this.setAttribute('aria-busy', 'false');
          this.primary.removeAttribute('aria-disabled');
          this.loadingLabel.hidden = true;
          this.error.hidden = false;
          this.status.textContent = '';
        };
        preload.src = option.dataset.image;
      }
      commit(option) {
        this.active = option;
        this.name.textContent = option.dataset.name;
        if (this.price) this.price.textContent = option.dataset.price;
        this.buyLabel.textContent = option.dataset.buyLabel;
        this.primary.href = option.dataset.url;
        this.dataset.selectedVariant = option.value;
        this.setAttribute('aria-busy', 'false');
        this.primary.removeAttribute('aria-disabled');
        this.loadingLabel.hidden = true;
        this.status.textContent = option.dataset.name;
      }
      disconnectedCallback() {
        this.sequence++;
        this.events?.abort();
        this.events = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["takt-product-tools"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('takt-product-tools')){
    customElements.define('takt-product-tools',class extends HTMLElement{
      async connectedCallback(){
        if(this.events)return;
        this.root=this.closest('product-info');
        this.events=new AbortController();
        const connection=this.events;
        this.map=JSON.parse(this.querySelector('[data-takt-gallery-map]').textContent);
        this.mediaOrder=JSON.parse(this.querySelector('[data-takt-media-order]').textContent);
        this.mediaGroups=JSON.parse(this.querySelector('[data-takt-media-groups]').textContent);
        this.showAllMedia=false;
        this.sticky=this.querySelector('[data-takt-sticky]');
        this.primary=this.root.querySelector('.product-form__submit');
        this.stickyButton=this.querySelector('[data-takt-sticky-submit]');
        const options={signal:this.events.signal};
        this.stickyButton.addEventListener('click',()=>{
          if(this.primary&&!this.primary.disabled&&this.primary.getAttribute('aria-disabled')!=='true')this.primary.click();
        },options);
        if(this.primary){
          this.primaryObserver=new MutationObserver(()=>this.syncBuy());
          this.primaryObserver.observe(this.primary,{attributes:true,childList:true,subtree:true});
          this.intersection=new IntersectionObserver(()=>this.updateSticky(),{threshold:[0,1]});
          this.intersection.observe(this.primary);
        }
        const updatePosition=()=>{
          if(this.scrollFrame)return;
          this.scrollFrame=requestAnimationFrame(()=>{this.scrollFrame=null;this.updateSticky();});
        };
        window.addEventListener('scroll',updatePosition,{...options,passive:true});
        this.viewportWidth=window.innerWidth;
        window.addEventListener('resize',()=>{
          updatePosition();
          if(this.viewportWidth===window.innerWidth)return;
          this.viewportWidth=window.innerWidth;
          this.resetGalleryGesture();
          clearTimeout(this.resizeTimer);
          this.resizeTimer=setTimeout(()=>this.applyMedia({keepActive:true,preserveScroll:true}),160);
        },options);
        this.updateSticky();
        this.variantUnsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{
          if(data.sectionId!==this.dataset.section)return;
          if(data.variant){this.dataset.variant=String(data.variant.id);this.applyMedia();this.syncBuy();}
        });
        this.errorUnsubscribe=subscribe(PUB_SUB_EVENTS.cartError,()=>{
          this.root.querySelector('product-form')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
        });
        this.syncBuy();
        await customElements.whenDefined('media-gallery');
        if(!this.isConnected||this.events!==connection)return;
        this.gallery=this.root.querySelector('media-gallery');
        this.viewer=this.gallery.querySelector('[id^=GalleryViewer]');
        this.viewerList=this.viewer.querySelector('ul');
        this.thumbList=this.gallery.querySelector('[id^=Slider-Thumbnails]');
        if(!this.gallery.querySelector('.takt-gallery-controls')){
          this.gallery.append(this.querySelector('[data-takt-controls]').content.cloneNode(true));
        }
        this.galleryMode=this.gallery.querySelector('[data-takt-gallery-mode]');
        this.galleryToggle=this.gallery.querySelector('[data-takt-gallery-toggle]');
        this.galleryControls=this.gallery.querySelector('.takt-gallery-controls');
        this.galleryToggle.addEventListener('click',()=>{
          this.showAllMedia=!this.showAllMedia;
          this.applyMedia({keepActive:true});
        },options);
        this.galleryToggle.disabled=false;
        this.gallery.querySelectorAll('[data-takt-step]').forEach(button=>{
          button.addEventListener('click',()=>this.go(Number(button.dataset.taktStep)),options);
          button.disabled=false;
        });
        this.viewerList.tabIndex=0;
        const startGesture=(x,y)=>{
          this.resetGalleryGesture();
          this.gestureStart={x,y};
        };
        const moveGesture=(x,y)=>{
          if(!this.gestureStart)return;
          const dx=Math.abs(x-this.gestureStart.x),dy=Math.abs(y-this.gestureStart.y);
          if(dx>10&&dx>dy){this.userGalleryScrolling=true;this.scheduleMediaSelection();}
        };
        this.viewerList.addEventListener('pointerdown',event=>startGesture(event.clientX,event.clientY),options);
        this.viewerList.addEventListener('pointermove',event=>moveGesture(event.clientX,event.clientY),options);
        this.viewerList.addEventListener('touchstart',event=>{const touch=event.touches[0];if(touch)startGesture(touch.clientX,touch.clientY);},{...options,passive:true});
        this.viewerList.addEventListener('touchmove',event=>{const touch=event.touches[0];if(touch)moveGesture(touch.clientX,touch.clientY);},{...options,passive:true});
        this.viewerList.addEventListener('pointerup',()=>{this.gestureStart=null;if(!this.userGalleryScrolling)this.resetGalleryGesture();},options);
        this.viewerList.addEventListener('touchend',()=>{this.gestureStart=null;if(!this.userGalleryScrolling)this.resetGalleryGesture();},{...options,passive:true});
        this.viewerList.addEventListener('click',()=>this.resetGalleryGesture(),options);
        this.viewerList.addEventListener('wheel',event=>{if(Math.abs(event.deltaX)>Math.abs(event.deltaY)){this.userGalleryScrolling=true;this.scheduleMediaSelection();}},{...options,passive:true});
        this.viewerList.addEventListener('scroll',()=>{if(this.userGalleryScrolling)this.scheduleMediaSelection();},{...options,passive:true});
        this.root.addEventListener('change',event=>{
          if(event.target.closest('variant-selects')){
            this.resetGalleryGesture();
            if(!this.gallerySelectingVariant)this.pendingMediaId=null;
          }
        },options);
        this.viewerList.addEventListener('keydown',event=>{
          if(event.altKey||event.ctrlKey||event.metaKey||event.shiftKey)return;
          if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.go(event.key==='ArrowRight'?1:-1);}
        },options);
        this.viewer.addEventListener('slideChanged',event=>{
          if(event.detail?.currentElement){
            const index=this.ids?.indexOf(event.detail.currentElement.dataset.mediaId);
            if(index>=0){
              this.index=index;this.syncCount();
              if(this.userGalleryScrolling)this.scheduleMediaSelection();
            }
          }
        },options);
        this.thumbList?.addEventListener('click',event=>{
          const target=event.target.closest('[data-target]');
          if(target){this.userGalleryScrolling=false;clearTimeout(this.mediaChangeTimer);this.index=this.ids.indexOf(target.dataset.target);this.syncCount();this.selectMediaVariant(target.dataset.target);}
        },options);
        this.applyMedia();
      }
      resetGalleryGesture(){
        this.userGalleryScrolling=false;
        this.gestureStart=null;
        clearTimeout(this.mediaChangeTimer);
      }
      scheduleMediaSelection(){
        clearTimeout(this.mediaChangeTimer);
        this.mediaChangeTimer=setTimeout(()=>{
          if(!this.userGalleryScrolling)return;
          const left=this.viewerList.getBoundingClientRect().left;
          const media=[...this.viewerList.querySelectorAll('li[data-media-id]')].filter(item=>!item.hidden).reduce((nearest,item)=>!nearest||Math.abs(item.getBoundingClientRect().left-left)<Math.abs(nearest.getBoundingClientRect().left-left)?item:nearest,null);
          this.resetGalleryGesture();
          if(media){
            this.viewerList.querySelectorAll('li[data-media-id]').forEach(item=>item.classList.toggle('is-active',item===media));
            this.selectMediaVariant(media.dataset.mediaId);
          }
        },240);
      }
      mediaOwners(mediaId){
        const dynamic=Object.entries(this.map).filter(([,variant])=>variant.linked_media===mediaId).map(([id])=>id);
        if(dynamic.length)return dynamic;
        return (this.mediaGroups.owners[mediaId]||[]).filter(id=>this.map[id]);
      }
      selectedMediaIds(allIds){
        if(!this.mediaGroups.enabled)return allIds;
        const state=this.map[this.dataset.variant];
        const shared=new Set(this.mediaGroups.shared);
        const selected=allIds.filter(id=>id===state?.featured||shared.has(id)||this.mediaOwners(id).includes(this.dataset.variant));
        if(!selected.length)return allIds;
        return selected.includes(state.featured)?[state.featured,...selected.filter(id=>id!==state.featured)]:selected;
      }
      currentMediaId(){
        const active=[...this.viewerList.querySelectorAll('li[data-media-id]')].find(item=>!item.hidden&&item.classList.contains('is-active'));
        return active?.dataset.mediaId||this.ids?.[this.index];
      }
      applyMedia({keepActive=false,preserveScroll=false}={}){
        if(!this.gallery)return;
        this.resetGalleryGesture();
        const state=this.map[this.dataset.variant];
        if(!state)return;
        const previousId=keepActive?this.currentMediaId():this.pendingMediaId;
        this.pendingMediaId=null;
        const allIds=this.mediaOrder.filter(id=>this.viewerList.querySelector('[data-media-id="'+this.dataset.section+'-'+id+'"]'));
        const selectedIds=this.selectedMediaIds(allIds);
        const visibleIds=this.showAllMedia?allIds:selectedIds;
        const visible=new Set(visibleIds.map(id=>this.dataset.section+'-'+id));
        this.ids=visibleIds.map(id=>this.dataset.section+'-'+id);
        const displayOrder=[...visibleIds,...allIds.filter(id=>!visibleIds.includes(id))];
        const reorder=(container,attribute,prefix)=>{
          if(!container)return;
          let cursor=container.firstElementChild;
          displayOrder.forEach(rawId=>{
            const item=container.querySelector('['+attribute+'="'+prefix+rawId+'"]');
            if(!item)return;
            if(item!==cursor)container.insertBefore(item,cursor);
            cursor=item.nextElementSibling;
          });
        };
        reorder(this.viewerList,'data-media-id',this.dataset.section+'-');
        reorder(this.thumbList,'data-target',this.dataset.section+'-');
        this.viewerList.querySelectorAll('li[data-media-id]').forEach(item=>{item.hidden=!visible.has(item.dataset.mediaId);});
        this.thumbList?.querySelectorAll('[data-target]').forEach(item=>{item.hidden=!visible.has(item.dataset.target);});
        const modal=document.getElementById('ProductModal-'+this.dataset.section);
        modal?.classList.add('takt-product-modal');
        const modalContent=modal?.querySelector('[role="document"]');
        reorder(modalContent,'data-media-id','');
        modal?.querySelectorAll('[data-media-id]').forEach(media=>{
          media.hidden=!visibleIds.includes(media.dataset.mediaId);
          if(media.hidden)media.classList.remove('active');
        });
        const preferredId=this.ids.includes(previousId)?previousId:this.dataset.section+'-'+state.featured;
        const selectedIndex=Math.max(0,this.ids.indexOf(preferredId));
        this.galleryMode.hidden=!this.mediaGroups.enabled||allIds.length===selectedIds.length;
        this.gallery.querySelector('[data-takt-gallery-label]').textContent=this.showAllMedia?this.dataset.allLabel:state.title;
        this.galleryToggle.textContent=this.showAllMedia?this.dataset.viewColour:this.dataset.viewAll;
        this.galleryToggle.setAttribute('aria-pressed',String(this.showAllMedia));
        this.viewer.resetPages?.();
        this.gallery.elements.thumbnails?.resetPages?.();
        this.index=selectedIndex;
        if(this.ids.length&&this.viewerList.querySelector('li.is-active:not([hidden])')?.dataset.mediaId!==this.ids[selectedIndex])this.gallery.setActiveMedia(this.ids[selectedIndex],false,!preserveScroll);
        if(window.innerWidth<750){
          this.root.querySelectorAll('.takt-color-options').forEach(row=>{
            const selected=row.querySelector('input:checked+label');
            if(!selected)return;
            const box=selected.getBoundingClientRect(),frame=row.getBoundingClientRect();
            if(box.left<frame.left)row.scrollLeft-=frame.left-box.left+4;
            else if(box.right>frame.right)row.scrollLeft+=box.right-frame.right+4;
          });
        }
        this.root.dataset.taktReady='true';
        this.syncCount();
      }
      go(step){
        this.userGalleryScrolling=false;
        clearTimeout(this.mediaChangeTimer);
        const index=Math.max(0,Math.min(this.ids.length-1,this.index+step));
        this.index=index;
        this.gallery.setActiveMedia(this.ids[index],false);
        this.syncCount();
        this.selectMediaVariant(this.ids[index]);
      }
      selectMediaVariant(mediaId){
        const rawId=mediaId?.slice(this.dataset.section.length+1);
        if(!rawId)return;
        const current=this.map[this.dataset.variant];
        const owners=this.mediaOwners(rawId);
        if(owners.includes(this.dataset.variant))return;
        const candidates=Object.entries(this.map).filter(([id])=>owners.includes(id));
        if(!candidates.length)return;
        const candidate=candidates.find(([,variant])=>variant.options.slice(1).every((value,index)=>value===current?.options[index+1]))||candidates[0];
        const picker=[...this.root.querySelectorAll('variant-selects')].find(el=>getComputedStyle(el).display!=='none');
        if(!picker)return;
        const groups=[...picker.querySelectorAll('fieldset,select')];
        const inputs=candidate[1].options.map((value,index)=>{
          const group=groups[index];
          if(group?.tagName==='SELECT')return [...group.options].find(option=>option.value===value);
          return group&&[...group.querySelectorAll('input[type=radio]')].find(input=>input.value===value);
        });
        if(inputs.some(input=>!input))return;
        let changed;
        inputs.forEach(input=>{
          if(input.tagName==='OPTION'){
            const select=input.parentElement;
            if(select.value!==input.value){select.value=input.value;changed=select;}
          }else if(!input.checked){input.checked=true;changed=input;}
        });
        if(changed){
          this.pendingMediaId=mediaId;
          this.gallerySelectingVariant=true;
          changed.dispatchEvent(new Event('change',{bubbles:true}));
          this.gallerySelectingVariant=false;
        }
      }
      syncCount(){
        if(!this.gallery||!this.ids)return;
        this.gallery.querySelector('.takt-gallery-controls').hidden=this.ids.length<2;
        this.gallery.querySelector('[data-takt-count]').textContent=(this.index+1)+' / '+this.ids.length;
        this.gallery.querySelector('[data-takt-step="-1"]').disabled=this.index===0;
        this.gallery.querySelector('[data-takt-step="1"]').disabled=this.index===this.ids.length-1;
        const thumb=this.thumbList?.querySelector('[data-target="'+this.ids[this.index]+'"]');
        if(thumb&&matchMedia('(min-width:750px)').matches){
          const item=thumb.getBoundingClientRect(),list=this.thumbList.getBoundingClientRect();
          if(item.top<list.top)this.thumbList.scrollTop-=list.top-item.top;
          else if(item.bottom>list.bottom)this.thumbList.scrollTop+=item.bottom-list.bottom;
        }
      }
      syncBuy(){
        if(!this.primary){this.sticky.hidden=true;return;}
        const state=this.map[this.dataset.variant];
        if(state){
          this.querySelector('[data-takt-sticky-price]').textContent=state.price;
          this.querySelector('[data-takt-sticky-color]').textContent=state.title;
        }
        this.stickyButton.disabled=this.primary.disabled||this.primary.getAttribute('aria-disabled')==='true';
        this.stickyButton.textContent=this.primary.querySelector('span')?.textContent.trim()||this.primary.textContent.trim();
      }
      updateSticky(){
        this.sticky.hidden=!this.primary||window.innerWidth>=750||this.primary.getBoundingClientRect().bottom>=0;
      }
      disconnectedCallback(){
        clearTimeout(this.mediaChangeTimer);
        clearTimeout(this.resizeTimer);
        this.events?.abort();
        this.primaryObserver?.disconnect();
        this.intersection?.disconnect();
        if(this.scrollFrame)cancelAnimationFrame(this.scrollFrame);
        this.variantUnsubscribe?.();
        this.errorUnsubscribe?.();
        this.galleryMode?.remove();
        this.galleryControls?.remove();
        this.events=null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
